import styled from 'styled-components';
import { ThemeInterface } from '../theme/ThemeInterface';
import { themeGet } from '@styled-system/theme-get';

const H4 = styled.h4`
  font-size: ${themeGet('fontSize[1]', '16px')};
  font-weight: 100;
  color: ${themeGet('colors.white', '#FFFFFF')};
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
  text-transform: ${(props: ThemeInterface) => props.textTransform || 'none'};
`;

export default H4;
